export default "__VITE_ASSET__D2pbv3KQ__"